
import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/compat/firestore";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { User } from "../models/user.model";

@Injectable()
export class UserService {
    private firebaseInvitedCollection: AngularFirestoreCollection;

    signOut = false;
    public isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    public userRole: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(
        private router: Router,
        private firebaseAuth: AngularFireAuth,
        private angularFirestore: AngularFirestore) {
        this.currentUserSubject = new BehaviorSubject<User>(
            JSON.parse(localStorage.getItem("currentUser"))
        );
        this.currentUser = this.currentUserSubject.asObservable();
        if (this.currentUserSubject.getValue() != null) {
            this.isLoggedIn.next(true);
        } else {
            this.isLoggedIn.next(false);
        }
    }
    

    public get currentUserValue(): any {
        return this.currentUserSubject.value;
    }


    login(user: User) {
        return this.firebaseAuth.signInWithEmailAndPassword(user.email, user.password);
    }

    firebaseLogin(user: User) {
        this.firebaseAuth.signInWithEmailAndPassword(user.email, user.password)
            .then(user => console.log(JSON.stringify(user)))
            .catch(error => console.log(error));
    }

    logout() {
        this.firebaseLogout();
    }

    firebaseLogout() {
        this.firebaseAuth.signOut().then(() => {
            this.currentUserSubject.next(null);
            localStorage.removeItem("currentUser");
            localStorage.removeItem("expert");
            localStorage.removeItem("doctorUser");
            localStorage.removeItem("expertUser");
            localStorage.clear();
            this.signOut = true;
            this.isLoggedIn.next(false);
            this.router.navigate(["/login"]);
        }).catch((error) => {
            console.log('Sign out error: ', error)
        })
    }

    resetPassword(email: string) {
        return this.firebaseAuth.sendPasswordResetEmail(email.toLocaleLowerCase());
    }

    logUser(value: boolean) {
        this.isLoggedIn.next(value);
    }

    setCurrentUser(user) {
        localStorage.setItem("currentUser", JSON.stringify(user));
        this.currentUserSubject.next(user);
    }

    async getActiveUser() {
        try {
            let user = null;
            this.firebaseAuth.currentUser.then((data) => {
                if (data != null) {
                    user = data.uid;
                    this.isLoggedIn.next(true);
                    return user;
                } else {
                    this.signOut = false;
                    this.isLoggedIn.next(false);
                    return null;
                }
            }).catch((err) => console.log('getActiveUser Error: ', err));
        } catch (err) {
            console.log('getActiveUser Error: ', err)
        }

    }

    async getCurrentUserAsync() {
        try {
            let currentUser = await this.firebaseAuth.currentUser;
            return currentUser;
        } catch (error) {
            console.log('requestAdditionalInfo(): ' + JSON.stringify(error));
        }
    }

    async checkUserExists(email: string) {
        try {
            let expert = null;

            if (this.firebaseInvitedCollection == null) {
                this.firebaseInvitedCollection = this.angularFirestore.collection('Invited');
            }

            await this.firebaseInvitedCollection.ref
                .doc(email)
                .get()
                .then(querySnapshot => {
                    const docData = {
                        id: querySnapshot.id,
                        ...querySnapshot.data()
                    }
                    expert = (docData);
                }).catch(err => console.log("checkUserExists query 1 error: " + err));

            return expert;
        } catch (error) {
            console.log('checkUserExists(): ' + JSON.stringify(error));
        }
    }
}
